<template>
  <v-container class="px-4 py-6">
    <v-skeleton-loader type="table">
    </v-skeleton-loader>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Alerts",
    props: {
      activeTab: String,
      enterprise: Object,
      permissionList: Array,
    },
    data() {
      return {
      }
    },
    watch: {
      activeTab(val) {
        // if (val === 'alerts') {
        //   this.getAlerts();
        // }
      }
    },
    mounted() {
      // if (this.activeTab === 'alerts') {
      //   this.getAlerts();
      // }
    },
    methods: {
    }
  }
</script>
<style scoped>
</style>